import { useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";

import {
  structureDataByMonth,
  getEventsByMonth,
  getUniqueEventDays,
  monthLabel,
} from "./calendarFunctions";

const CalendarHeader = ({
  data,
  tags = [],
  activeTags = [],
  onToggleTag,
  search = "",
  onSearchChange,
}) => {
  const [structuredData, setStructuredData] = useState();
  const [selectedMonthEvents, setSelectedMonthEvents] = useState({});
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  const spansMultipleYears =
    new Set(Object.keys(structuredData || {}).map((k) => k.slice(0, 4))).size >
    1;

  function handleDateSelected(day) {
    setSelectedDate(day);
  }

  useEffect(() => {
    if (data.length) {
      const structured = structureDataByMonth(data);
      setStructuredData(structured);
      setSelectedMonth(Object.keys(structured)[0]);
    }
  }, [data, setSelectedMonth]);
  useEffect(() => {
    if (structuredData) {
      const monthlyEvents = getEventsByMonth(selectedMonth, structuredData);
      const uniqueEventDays = getUniqueEventDays(monthlyEvents);
      setSelectedMonthEvents(uniqueEventDays);
      setSelectedDate(uniqueEventDays[0]);
    }
  }, [selectedMonth, structuredData]);

  useEffect(() => {
    if (selectedDate) {
      const card = document.getElementById(selectedDate.id);
      const header = document.getElementById("calendar-header");

      if (card && header) {
        const cardRect = card.getBoundingClientRect();
        const headerRect = header.getBoundingClientRect();

        // Calculate the top position to scroll to
        const topPositionToScroll =
          cardRect.top + window.pageYOffset - headerRect.height - 24;

        // Scroll to the calculated position
        window.scroll({
          top: topPositionToScroll,
          behavior: "smooth",
        });
      }
    }
  }, [selectedDate]);

  return (
    <nav id="calendar-header">
      <div id="back">
        <button
          className="nav-button"
          aria-label="back"
          onClick={() => window.history.back()}
        >
          <IoIosArrowBack fontSize={"18px"} />
        </button>
      </div>
      <div className="scroll-container">
        <input
          type="search"
          placeholder="Search events"
          value={search}
          onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
          className="search-input"
          aria-label="Search events"
        />
      </div>
      {!!tags.length && (
        <div className="scroll-container">
          {tags.map((tag) => (
            <button
              key={tag}
              className={`nav-button ${
                activeTags.includes(tag) ? "selected-button" : ""
              }`}
              onClick={(e) => {
                onToggleTag && onToggleTag(tag);
                e.currentTarget.blur();
              }}
            >
              {tag}
            </button>
          ))}
        </div>
      )}
      <div className="scroll-container">
        {!!structuredData &&
          Object.keys(structuredData).map((month) => (
            <button
              className={`nav-button ${
                month === selectedMonth ? "selected-button" : ""
              }`}
              onClick={(e) => setSelectedMonth(month)}
              key={month}
            >
              {monthLabel(month, spansMultipleYears)}
            </button>
          ))}
      </div>
      <div className="scroll-container">
        {!!selectedMonthEvents.length &&
          selectedMonthEvents.map((day) => (
            <button
              className={`nav-button ${
                selectedDate?.key === day.key ? "selected-button" : ""
              }`}
              key={day.key}
              onClick={() => handleDateSelected(day)}
            >
              <span className="date">{day.dayOfWeek} </span>
              <span className="date">{day.date}</span>
            </button>
          ))}
      </div>
      <div className="days"></div>
    </nav>
  );
};
export default CalendarHeader;
